var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIceBucket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 60,
    viewBox: "-3 -10 130 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.449 13.5434L9.19516 9.89941L7.76215 13.9685L10.449 13.5434Z",
    fill: "#90B2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4491 13.5434L11.5238 11.4177L9.19519 9.89941L10.4491 13.5434Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5238 11.4178L10.1505 9.23145L9.19519 9.89951L11.5238 11.4178Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7185 14.272L17.0767 9.65625L11.5238 11.4175L16.7185 14.272Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8233 9.95991L17.017 9.65625L16.7184 14.272L19.8233 9.95991Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9578 12.0249L19.8233 9.95996L16.7184 14.272L20.9578 12.0249Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8233 9.96006L18.1515 9.29199L17.017 9.65639L19.8233 9.96006Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0631 14.6371L28.4214 13.2402L26.2122 11.9648L28.0631 14.6371Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4214 13.2402L31.7053 9.41406L26.2719 11.9648L28.4214 13.2402Z",
    fill: "#CBEAF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1981 12.0254L31.7054 9.47461L28.4214 13.3008L33.1981 12.0254Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1981 12.0254L28.4214 13.3008L28.0631 14.6369L33.1981 12.0254Z",
    fill: "#91ACB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6923 14.3937L47.8267 12.4502L42.2141 13.179L46.6923 14.3937Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6923 14.515V14.3328L42.2141 13.1182L46.6923 14.515Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2141 13.179L47.8267 12.4502L42.2141 13.179Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5733 13.908L47.8267 12.3896L46.6923 14.3331L50.5733 13.908Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5733 13.9075L52.3049 9.35254L47.767 12.3892L50.5733 13.9075Z",
    fill: "#CBEAF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4393 10.2635L52.3049 9.35254L50.5733 13.9075L53.4393 10.2635Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3199 14.7577L53.4393 10.3242L50.5733 13.9682L53.3199 14.7577Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9024 11.4176L53.4393 10.2637L53.3199 14.6972L56.9024 11.4176Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3646 9.35254L53.499 10.2635L52.3646 9.35254Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9024 11.4176L58.0966 10.6888L53.4393 10.2637L56.9024 11.4176Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0374 12.9366L58.0966 10.6895L56.9024 11.4182L62.0374 12.9366Z",
    fill: "#C5DCED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9932 12.329L66.8738 11.418L62.0374 12.8756L66.9932 12.329Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9932 12.329L67.2917 12.0253L66.8738 11.418L66.9932 12.329Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2917 12.0252L71.2922 10.5068L66.8738 11.4786L67.2917 12.0252Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5471 12.9364V12.6935L77.7408 12.0254L80.5471 12.9364Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5471 12.9363L84.4282 13.1792L80.5471 12.6934V12.9363Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4879 13.1787L85.2641 11.9033L80.6068 12.6928L84.4879 13.1787Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8762 13.058L85.2044 11.9648L84.4282 13.2402L86.8762 13.058Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8763 13.0572L86.4583 10.0205L85.2044 11.964L86.8763 13.0572Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8762 13.0577L88.4883 9.53516L86.4583 9.96029L86.8762 13.0577Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6529 12.2681L88.4287 9.53516L86.8165 13.0577L91.6529 12.2681Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7126 12.5105V12.2676L86.9359 12.9964L91.7126 12.5105Z",
    fill: "#CBEAF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.235 14.7577L91.6529 12.5713L86.8165 13.0572L91.235 14.7577Z",
    fill: "#CBEAF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5636 12.3896L91.7126 12.5111L91.2947 14.6975L93.5636 12.3896Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7126 12.5105L93.5636 12.389L91.7126 12.2676V12.5105Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.848 14.758L99.1165 10.5674L98.4597 11.6606L100.848 14.758Z",
    fill: "#D2F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.848 14.7578L100.43 9.65625L99.1165 10.5672L100.848 14.7578Z",
    fill: "#7894A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.848 14.7578L103.057 14.6364L100.43 9.65625L100.848 14.7578Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.19519 9.89988L10.1505 9.23182L9.19519 6.55957V9.89988Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7777 5.46643L9.79223 4.3125L9.13544 6.55962L12.7777 5.46643Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1505 9.23126L12.7777 5.46582L9.13544 6.55901L10.1505 9.23126Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7777 5.46634L10.7476 2.42969L9.79224 4.31241L12.7777 5.46634Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5238 11.4177L12.7777 5.46582L10.1505 9.23127L11.5238 11.4177Z",
    fill: "#B2D1ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.017 9.6564L12.7777 5.46582L11.5238 11.4177L17.017 9.6564Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7777 5.46638L11.4641 1.45801L10.7476 2.42974L12.7777 5.46638Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7777 5.46638L17.1961 3.94806L11.4641 1.45801L12.7777 5.46638Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.017 9.65616L17.1962 3.94727L12.7777 5.46559L17.017 9.65616Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1515 9.29177L17.1962 3.94727L17.017 9.65616L18.1515 9.29177Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1515 9.29177L20.4204 8.68444L17.2559 3.94727L18.1515 9.29177Z",
    fill: "#90B2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4204 8.68449L21.1966 2.97559L17.1961 3.88658L20.4204 8.68449Z",
    fill: "#90B2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.734 3.33998L21.1966 2.97559L20.4204 8.68449L21.734 3.33998Z",
    fill: "#90B2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1966 2.97624L20.0025 2.12598L17.2559 3.88723L21.1966 2.97624Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8233 9.95996L20.4204 8.68457L18.1515 9.2919L19.8233 9.95996Z",
    fill: "#8CA8BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6893 8.19848L21.734 3.33984L20.4204 8.68435L22.6893 8.19848Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6893 8.19922L20.4204 8.68508L19.8233 9.96047L22.6893 8.19922Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9578 12.0252L22.6893 8.25977L19.8233 9.96029L20.9578 12.0252Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.734 3.34036L25.9136 1.5791L21.1966 3.03669L21.734 3.34036Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7345 11.6003L22.6893 8.19922L20.9578 11.9647L25.7345 11.6003Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6893 8.19867L27.5258 4.67616L21.734 3.2793L22.6893 8.19867Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2272 7.28809L27.466 4.7373L22.6893 8.19908L27.2272 7.28809Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5258 4.73722L25.9136 1.5791L21.734 3.34036L27.5258 4.73722Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7345 11.6001L27.2272 7.28809L22.6893 8.19908L25.7345 11.6001Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5854 7.10589L27.5257 4.7373L27.2272 7.28809L27.5854 7.10589Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2121 11.9645L27.2272 7.28809L25.7344 11.6001L26.2121 11.9645Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5854 7.10589L28.0631 6.68076L27.5257 4.7373L27.5854 7.10589Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7054 9.41374L27.2272 7.28809L26.2122 11.9645L31.7054 9.41374Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5258 4.73717V0L25.9136 1.57906L27.5258 4.73717Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8694 1.39686L27.5257 0L27.466 4.73717L30.8694 1.39686Z",
    fill: "#7AC2CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7053 9.41332L27.5854 7.10547L27.2272 7.28767L31.7053 9.41332Z",
    fill: "#CBEAF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7053 9.41365L28.0631 6.68066L27.5854 7.10579L31.7053 9.41365Z",
    fill: "#CBEAF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7053 9.41365L31.8845 8.92778L28.0631 6.68066L31.7053 9.41365Z",
    fill: "#C5DCED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0631 6.68025L33.198 2.67188L27.5257 4.7368L28.0631 6.68025Z",
    fill: "#90B2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1981 2.67188L30.9291 1.39648L27.5854 4.67606L33.1981 2.67188Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8845 8.92737L33.1981 2.67188L28.0631 6.68025L31.8845 8.92737Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5865 5.22266L33.1981 2.67188L31.8845 8.92737L35.5865 5.22266Z",
    fill: "#9FB6BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1981 12.0251L34.1535 12.1466L31.8845 8.92773L33.1981 12.0251Z",
    fill: "#C5DCED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1836 5.95145L35.5865 5.22266L31.8845 8.86664L36.1836 5.95145Z",
    fill: "#D2F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.198 12.0251L31.8845 8.92773L31.7053 9.4136L33.198 12.0251Z",
    fill: "#C5DCED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0937 12.1467L36.1238 6.0127L31.8248 8.92788L34.0937 12.1467Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2282 12.5113L36.1835 5.95215L34.0937 12.1469L35.2282 12.5113Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5864 5.22299L38.9898 0.97168L33.1981 2.6722L35.5864 5.22299Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5417 13.2401L36.1835 5.95215L35.2281 12.5113L36.5417 13.2401Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5417 13.2401L42.1543 8.68513L36.1835 5.95215L36.5417 13.2401Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8855 4.31199L38.9301 0.97168L35.5267 5.22299L39.8855 4.31199Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1544 8.68513L41.8558 7.22754L36.1238 5.95215L42.1544 8.68513Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1835 5.95229L39.8855 4.3125L35.5864 5.22349L36.1835 5.95229Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2141 13.1181V8.68457L36.6014 13.2395L42.2141 13.1181Z",
    fill: "#C5DCED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9155 7.22768L39.8854 4.3125L36.1835 5.95229L41.9155 7.22768Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8855 4.31199L50.0359 3.9476L38.9301 0.97168L39.8855 4.31199Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0359 3.9476L50.8719 1.27534L38.9301 0.97168L50.0359 3.9476Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9155 7.22768L49.2 5.89156L39.8854 4.3125L41.9155 7.22768Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2 5.89072L50.0359 3.94727L39.8854 4.31166L49.2 5.89072Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2141 13.1181L47.8267 12.45L42.1544 8.68457L42.2141 13.1181Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1544 8.68513L49.2 5.95215L41.9155 7.28827L42.1544 8.68513Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8267 12.3891L49.2 5.89062L42.1544 8.62361L47.8267 12.3891Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2898 8.26L49.2 5.95215L47.8267 12.4506L51.2898 8.26Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7078 8.56362L51.2898 8.19922L47.8267 12.3898L51.7078 8.56362Z",
    fill: "#CBEAF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3646 9.353L51.7675 8.56348L47.8267 12.3897L52.3646 9.353Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3646 9.35301L51.7675 8.56348L52.3646 9.35301Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2898 2.91518L50.8719 1.27539L50.0359 3.94764L51.2898 2.91518Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2898 8.2601L49.9762 4.00879L49.1403 5.95224L51.2898 8.2601Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2899 8.25936L55.2306 4.19025L51.2899 2.97559V8.25936Z",
    fill: "#B2D1ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2898 8.25936V2.97559L50.0359 4.00805L51.2898 8.25936Z",
    fill: "#90B2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7078 8.5632L55.2306 4.19043L51.2899 8.25954L51.7078 8.5632Z",
    fill: "#90B2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.35 4.3119L55.2306 4.19043L51.7078 8.5632L55.35 4.3119Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2898 2.91518L55.5889 1.39686L50.9316 1.27539L51.2898 2.91518Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2306 4.1902L55.5291 1.39648L51.2301 2.91481L55.2306 4.1902Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3049 9.35334L55.35 4.3125L51.7078 8.62454L52.3049 9.35334Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4393 10.2635L55.35 4.25098L52.3049 9.29181L53.4393 10.2635Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5592 5.16276L55.35 4.3125L53.4393 10.3251L57.5592 5.16276Z",
    fill: "#90B2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0966 10.6888L57.5592 5.16211L53.4393 10.2637L58.0966 10.6888Z",
    fill: "#90B2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.35 4.31167L55.5291 1.39648L55.2306 4.1902L55.35 4.31167Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5592 5.16193L55.5889 1.39648L55.4097 4.31167L57.5592 5.16193Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5592 5.16193L59.7087 2.36821L55.5291 1.39648L57.5592 5.16193Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7087 2.36826L58.0966 0.424805L55.5291 1.3358L59.7087 2.36826Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0966 10.6888L60.6641 7.10556L57.5593 5.16211L58.0966 10.6888Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4403 3.21843L59.7088 2.36816L57.5593 5.16188L61.4403 3.21843Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6641 7.10566L61.4403 3.21875L57.5593 5.16221L60.6641 7.10566Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0374 12.9358L60.6641 7.10547L58.0966 10.6887L62.0374 12.9358Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0374 12.9362L63.5898 6.98438L60.6641 7.10584L62.0374 12.9362Z",
    fill: "#49738C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1869 4.73707L61.4403 3.21875L60.6641 7.10566L64.1869 4.73707Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5898 6.98443L64.1272 4.7373L60.6044 7.10589L63.5898 6.98443Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8738 11.4181L63.5898 6.92383L62.0374 12.8757L66.8738 11.4181Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1869 4.73703L63.1121 2.91504L61.4403 3.2187L64.1869 4.73703Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8738 11.4181L67.5306 7.22749L63.6495 6.92383L66.8738 11.4181Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1869 4.73703L72.0685 3.4009L63.1122 2.91504L64.1869 4.73703Z",
    fill: "#AFC5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8893 4.0087L72.1281 3.40137L64.2466 4.73749L71.8893 4.0087Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5306 7.28809L64.1869 4.7373L63.6495 6.98443L67.5306 7.28809Z",
    fill: "#C5DCED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5306 7.28837L71.8893 4.00879L64.1869 4.73759L67.5306 7.28837Z",
    fill: "#CBEAF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2922 10.5069L67.5306 7.28809L66.8738 11.4787L71.2922 10.5069Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2922 10.5072L71.8296 4.00879L67.4709 7.28837L71.2922 10.5072Z",
    fill: "#94B9D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4272 6.31664L71.8893 4.00879L71.3519 10.5072L76.4272 6.31664Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4272 6.31636L73.2626 3.46191L71.8893 4.00851L76.4272 6.31636Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1884 12.086L76.4272 6.31641L71.2922 10.507L76.1884 12.086Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2626 3.4621L72.1282 3.40137L71.8893 4.0087L73.2626 3.4621Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3675 12.0859L76.4272 6.37695L76.1884 12.1466L76.3675 12.0859Z",
    fill: "#90B2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4272 6.31618L79.4723 0.97168L73.2626 3.46173L76.4272 6.31618Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7408 6.74154L76.4272 6.31641L76.3675 12.0253L77.7408 6.74154Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7408 12.025L77.681 6.74121L76.3077 12.025H77.7408Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7408 6.74131L79.4723 0.97168L76.4272 6.31618L77.7408 6.74131Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7262 6.61985L79.4723 0.97168L77.7408 6.74131L80.7262 6.61985Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7408 12.0254L80.7262 6.62012L77.7408 6.74158V12.0254Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.219 7.53111L80.7262 6.62012L80.5471 12.6934L82.219 7.53111Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5471 12.6934L80.7262 6.62012L77.7408 12.0254L80.5471 12.6934Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7262 6.61985L86.4582 2.24707L79.4723 0.97168L80.7262 6.61985Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2189 7.53084L86.4582 2.24707L80.7262 6.61984L82.2189 7.53084Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2044 11.904L82.219 7.53125L80.5471 12.6936L85.2044 11.904Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2044 11.904L86.4583 9.96057L82.2189 7.53125L85.2044 11.904Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2495 6.25545L86.4583 2.24707L82.2189 7.53084L88.2495 6.25545Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4583 9.96057L88.2495 6.25586L82.2189 7.53125L86.4583 9.96057Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4883 9.53544L88.2495 6.25586L86.4583 9.96057L88.4883 9.53544Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2495 6.25526L89.6228 2.42908L86.4583 2.30762L88.2495 6.25526Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5781 4.06948L89.6228 2.42969L88.2495 6.25587L90.5781 4.06948Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4884 9.53544L94.6384 7.47052L88.3093 6.25586L88.4884 9.53544Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5786 7.47038L90.5781 4.06934L88.2495 6.25572L94.5786 7.47038Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5781 4.06948L90.399 2.91555L89.6228 2.42969L90.5781 4.06948Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6529 12.2676L94.5786 7.46973L88.4286 9.53465L91.6529 12.2676Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5636 12.3891L94.5786 7.46973L91.6529 12.2676L93.5636 12.3891Z",
    fill: "#C5DCED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.116 8.01632L94.5786 7.46973L93.5636 12.3891L95.116 8.01632Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5787 7.47038L95.3549 6.55939L90.5782 4.06934L94.5787 7.47038Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5782 4.06897L95.3549 6.55902L90.399 2.91504L90.5782 4.06897Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3549 6.55893L98.7583 1.03223L90.399 2.85422L95.3549 6.55893Z",
    fill: "#C5DCED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4597 11.6606L95.116 8.0166L93.5039 12.3894L98.4597 11.6606Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4597 11.6606L99.1165 10.5674L95.116 8.0166L98.4597 11.6606Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1161 8.01707L96.0117 7.22754L94.5787 7.47047L95.1161 8.01707Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0117 7.22763L95.3549 6.55957L94.5787 7.47056L96.0117 7.22763Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0117 7.22699L98.7582 1.03223L95.3549 6.55893L96.0117 7.22699Z",
    fill: "#CBEAF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1165 10.5679L96.0117 7.22754L95.116 8.01707L99.1165 10.5679Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.684 3.82576L98.7583 1.09277L96.0117 7.28754L101.684 3.82576Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.609 8.74554L101.684 3.82617L96.0117 7.22722L100.609 8.74554Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1165 10.5679L100.609 8.74586L96.0117 7.22754L99.1165 10.5679Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.43 9.59538L100.609 8.74512L99.1165 10.5671L100.43 9.59538Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.221 8.92774L101.684 3.82617L100.609 8.74554L102.221 8.92774Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.057 14.6366L102.221 8.92773L100.43 9.65653L103.057 14.6366Z",
    fill: "#D2F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.057 14.6366L104.789 9.83873L102.162 8.92773L103.057 14.6366Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.221 8.92811L100.609 8.80664L100.43 9.6569L102.221 8.92811Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.312 3.34068L107.655 1.1543L101.624 3.82655L108.312 3.34068Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.073 4.49377L108.312 3.33984L101.684 3.82571L108.073 4.49377Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.221 8.92774L104.849 9.83874L101.744 3.82617L102.221 8.92774Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.849 9.83874L108.073 4.49423L101.684 3.82617L104.849 9.83874Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.923 9.77791L108.073 4.49414L104.849 9.83864L105.923 9.77791Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.939 8.32032L108.073 4.49414L105.923 9.77791L110.939 8.32032Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.775 10.5067L110.939 8.32031L105.864 9.7779L111.775 10.5067Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.596 8.31995L108.312 3.33984L108.073 4.49377L111.596 8.31995Z",
    fill: "#90B2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.939 8.32032H111.596L108.013 4.49414L110.939 8.32032Z",
    fill: "#90B2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.596 8.32018L114.641 2.30762L108.312 3.34008L111.596 8.32018Z",
    fill: "#90B2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.641 2.30809L112.85 0.243164L108.312 3.34055L114.641 2.30809Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.268 5.64793L114.641 2.30762L111.596 8.32018L117.268 5.64793Z",
    fill: "#D2F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.372 9.04911L111.596 8.32031H110.939L112.372 9.04911Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.775 10.5067L112.372 9.04911L110.939 8.32031L111.775 10.5067Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.372 9.04949L117.208 5.64844L111.596 8.32069L112.372 9.04949Z",
    fill: "#90B2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.268 7.95648V5.58789L112.432 8.98894L117.268 7.95648Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.238 16.4588L118.044 8.86719L111.715 10.507L115.238 16.4588Z",
    fill: "#D2F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.104 8.86719L112.372 9.04939L111.775 10.507L118.104 8.86719Z",
    fill: "#D2F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.104 8.86705L117.268 7.95605L112.372 8.98852L118.104 8.86705Z",
    fill: "#C6EBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.447 16.641L118.104 8.86719L115.238 16.4588L117.447 16.641Z",
    fill: "#7894A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.761 16.2766L118.104 8.86719L117.447 16.641L118.761 16.2766Z",
    fill: "#D2F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.268 5.64793L117.328 5.5872L114.641 2.30762L117.268 5.64793Z",
    fill: "#D2F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.94 17.9159C122.94 18.2803 122.701 18.584 122.403 18.7054L114.76 21.0133C114.76 21.0133 114.7 21.2562 114.641 21.5599C114.462 22.2279 114.223 23.3211 113.984 24.1714C113.924 24.4143 113.865 24.718 113.805 24.8395C113.506 26.2363 112.67 27.0866 111.954 27.1473C110.819 27.208 109.506 27.1473 109.506 27.1473C109.506 27.1473 106.52 42.9379 105.923 53.9306C105.804 56.4206 103.057 57.9997 99.3553 57.9997C79.2335 57.9997 43.7665 57.9997 23.6447 57.9997C19.9427 57.9997 17.1961 56.4206 17.0767 53.9306C16.4796 42.9379 13.4942 27.1473 13.4942 27.1473C13.4942 27.1473 12.1806 27.208 11.0461 27.1473C10.3296 27.0866 9.43398 26.1756 9.19514 24.8395C9.13544 24.6573 9.13544 24.4143 9.01602 24.1714C8.83689 23.3819 8.53835 22.2279 8.35922 21.5599C8.29951 21.1955 8.23981 21.0133 8.23981 21.0133L0.597087 18.7054C0.238835 18.584 0 18.2196 0 17.8552C0.0597087 16.5798 0.179126 13.6646 0.179126 11.3567C0.179126 8.25935 3.34369 8.07715 3.34369 8.07715H119.656C119.656 8.07715 122.821 8.25935 122.821 11.3567C122.761 13.6646 122.881 16.6405 122.94 17.9159Z",
    fill: "#54BCE3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.18011 20.9531H15.4049L19.7039 53.3238C19.7039 53.3238 19.2262 58.6683 29.6753 57.9395H23.6447C23.6447 57.9395 17.3156 58.061 17.0767 53.8704C16.7782 49.194 16.1811 42.5133 13.4942 27.1479C13.4942 27.1479 12.3 27.2086 11.0461 27.1479C10.1505 27.0872 9.434 26.0547 9.13545 24.84C8.59808 22.6536 8.18011 20.9531 8.18011 20.9531Z",
    fill: "#190A0B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M3.28399 8.0166L2.20923 13.3004C1.67185 15.9726 2.80632 18.8271 5.25438 20.0417C5.49321 20.1632 5.67234 20.2239 5.91117 20.2847L0.537387 18.7056C0.537387 18.7056 -0.119409 18.5841 -0.0597 17.8553C8.75443e-06 17.1266 0.119426 10.8711 0.119426 10.8711C0.119426 10.8711 0.179135 8.44173 3.28399 8.0166Z",
    fill: "#190A0B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M114.581 20.9531H104.789L100.55 53.3238C100.55 53.3238 100.132 57.2715 93.1456 57.9395H99.1762C99.1762 57.9395 105.505 58.061 105.744 53.8704C106.043 49.194 106.64 42.5133 109.327 27.1479C109.327 27.1479 110.521 27.2086 111.775 27.1479C112.67 27.0872 113.387 26.0547 113.685 24.84C114.163 22.6536 114.581 20.9531 114.581 20.9531Z",
    fill: "#190A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35925 20.6494H114.641L114.55 21.2567H8.49522L8.35925 20.6494Z",
    fill: "#3185A6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M119.477 8.0166V16.8229C119.477 16.8229 119.059 19.6166 116.79 20.2847L122.164 18.7056C122.164 18.7056 122.821 18.5841 122.761 17.8553C122.701 17.1266 122.582 10.8711 122.582 10.8711C122.582 10.8711 122.582 8.44173 119.477 8.0166Z",
    fill: "#190A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.462 21.1455C114.402 21.8743 113.745 22.9068 113.626 23.757H8.9563C8.77717 22.9675 8.47863 21.8136 8.2995 21.1455H114.462Z",
    fill: "#4898B8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.0894 58H34.6311L31.217 23.5625H15.5243L19.4774 53.8502C19.7769 56.2038 21.7535 58 24.0894 58Z",
    fill: "#328EB0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.4495 20.9527H31.3471L30.6306 8.0166H13.733L14.4495 20.9527Z",
    fill: "#328EB0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIceBucket);
export default __webpack_public_path__ + "static/media/Ice_Bucket.b383387af3b9a6bf3b71145dd841fac1.svg";
export { ForwardRef as ReactComponent };